import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=1957a4d6&scoped=true&"
import script from "./tongji.vue?vue&type=script&lang=js&"
export * from "./tongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1957a4d6",
  null
  
)

export default component.exports